<form #currentForm="ngForm" novalidate>
  <div class="form-group">
    <label>Detail Type</label>
    <select required class="form-control" #detail_type_id="ngModel" name="detail_type_id" [(ngModel)]="detail.detail_type_id">
      <option *ngFor="let detail_type of form_options.detail_types" [value]="detail_type.id">{{ detail_type.name }}</option>
    </select>
    <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(detail_type_id)">Detail type needs to be selected</div>
  </div>
  <div class="form-group">
    <label>Value</label>
    <app-tinymce #tinymce [initialContent]="detail.value" (onEditorKeyup)="detail.value = $event"></app-tinymce>
    <div class="alert alert-danger alert-padding-sm" [hidden]="!(!detail.value && formSubmitted)">Detail value needs to be entered</div>
  </div>
  <div class="form-group text-center">
    <button type="button" [disabled]="formSubmitting" class="btn btn-sm btn-primary" (click)="saveDetail(currentForm.form.valid)">Save</button>
    &nbsp;
    <button type="button" [disabled]="formSubmitting" class="btn btn-sm btn-secondary" (click)="cancelForm()">Cancel</button>
  </div>
</form>
